import { useEffect } from 'react';
export const META_PIXEL_ID = '1378262201133779';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      queue?: unknown[];
      loaded?: boolean;
    };
    _fbq?: unknown;
    __saPixelReady?: boolean;
  }
}

/**
 * Loads the Meta pixel and tracks a single PageView. No other events are fired.
 */
export function MetaPixel() {
  useEffect(() => {
    // Guard against double execution (StrictMode remounts, re-renders).
    if (window.__saPixelReady) return;
    window.__saPixelReady = true;
    if (!window.fbq) {
      const fbq: any = function (...args: unknown[]) {
        fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args);
      };
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
      window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return null;
}